import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../components/ToastMsg";
import BeatLoader from "react-spinners/BeatLoader";
import { ClipLoader } from "react-spinners";
import * as XLSX from 'xlsx';
import { addNewBulk } from "../../../redux/features/bulkUpload/bulkUploadService";
import { getAllActiveCourses } from "../../../redux/features/course/courseService";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { selectActiveCertificateTypesList } from "../../../redux/features/certificateType/certificateTypeSlice";
import { getActiveCertificateTypes } from "../../../redux/features/certificateType/certificateTypeService";
import { getCertificateTemplatesByTypeAndEntity } from "../../../redux/features/certificateTemplate/certificateTemplateService";

const OFFICIAL_HEADERS = [
  "student_id",
  "student_name",
  "program",
  "completion_date",
  "issued_date",
  "certificate_issue_year"
];

const OTHER_HEADERS = [
  "student_id",
  "student_name",
  "certificate_phrase_1",
  "certificate_phrase_2",
  "certificate_phrase_3",
  "course_or_event",
  "conducted_by_phrase",
  "conducted_by",
  "completion_phrase",
  "completion_date",
  "issued_date",
  "certificate_issue_year",
  "signature_name_1",
  "signature_designation_1",
  "signature_name_2",
  "signature_designation_2"
];

const BulkUpload = () => {

    const dispatch = useDispatch();
    const fileInputRef = useRef(null);
    const entityDropdownRef = useRef(null);
    const courseDropdownRef = useRef(null);
    const typeDropdownRef = useRef(null);
    const templateDropdownRef = useRef(null);

    const { data: certificateTypes } = useSelector(selectActiveCertificateTypesList);
    const { activeCourses } = useSelector((state) => state.course.allActiveCourses);

    const { isBulkCreating } = useSelector((state) => state.bulk.newBulk);
    const [certificateTemplates, setCertificateTemplates] = useState([]);

    const [formData, setFormData] = useState({
        certificate_template_id: '',
        file: '',
    });

    const [errorMessages, setErrorMessages] = useState({
        certificate_template_id: '',
        file: '',
    });
    const [disabledBtn, setBtnDisable] = useState(false);
    const [fileContent, setFileContent] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
  
    const [selectedCourse, setSelectedCourse] = useState({
        id: '',
        name: ''
    });
    const [selectedType, setSelectedType] = useState({
        id: '',
        name: ''
    });
    const [selectedTemplate, setSelectedTemplate] = useState({
        id: '',
        name: ''
    });
    const [isErrorMessage, setErrorMessage] = useState(false);
    const [courseLoadng, setCourseLoading] = useState(false);
    const [templateLoadng, setTemplateLoading] = useState(false);

    const fetchDetails = useCallback(() => {
        dispatch(getActiveCertificateTypes());
    }, [dispatch]);

    useEffect(() => {
        fetchDetails();
    }, [fetchDetails]);

    // const handleSelectEntity = async (option) => {
    //     setCourseLoading(true);
    //     setEntityCourses([]);
    //     setCertificateTemplates([]);
    //     setSelectedCourse({ id: '', name: '' });
    //     setSelectedTemplate({ id: '', name: '' })
    //     setFormData({ ...formData, certificate_entity_id: option.id });
    //     setErrorMessages({ ...errorMessages, entity: "" });
    //     setSelectedEntity({
    //         id: option.id,
    //         name: option.name
    //     });
    //     const response = await dispatch(getAllActiveCourses({ entityId: option.id })).unwrap();
    //     setEntityCourses(response);
    //     setCourseLoading(false);
    //     if (selectedType.id !== '') {
    //         setTemplateLoading(true);
    //         const response = await dispatch(getCertificateTemplatesByTypeAndEntity({ typeId: selectedType.id, entityId: option.id })).unwrap();
    //         setCertificateTemplates(response);
    //         setTemplateLoading(false);
    //     }
    // };

    const handleType = async (option) => {
        setTemplateLoading(true);
        setCertificateTemplates([]);
        setSelectedTemplate({ id: '', name: '' })
        setErrorMessages({ ...errorMessages, type: '' });
        setSelectedType({
            id: option.id,
            name: option.name,
        });
            const response = await dispatch(getCertificateTemplatesByTypeAndEntity({ typeId: option.id })).unwrap();
            setCertificateTemplates(response);
            setTemplateLoading(false);
    };

    const handleTemplate = (option) => {
        setFormData({ ...formData, certificate_template_id: option.id });
        setErrorMessages({ ...errorMessages, certificate_template_id: "" });
        setSelectedTemplate({
            id: option.id,
            name: option.name
        });
    };

    const readFileContent = async (file) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = event.target.result;
            let headers;
            const workbook = XLSX.read(data, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });
            headers = worksheet[0];
            setErrorMessage(false);
            const headerMapping = {};
            headers.forEach((header, index) => {
                headerMapping[header] = index;
            });
            const formattedContent = worksheet.slice(1).map(row => {
                if (row[headerMapping['birthday']] && !isNaN(row[headerMapping['birthday']])) {
                    row[headerMapping['birthday']] = XLSX.SSF.format("yyyy-mm-dd", row[headerMapping['birthday']]); // Convert to date string
                }
                return row;
            });

            setFileContent([headers, ...formattedContent]);
        };
        reader.readAsArrayBuffer(file);
    };

    const handleFileChange = (event) => {
        setErrorMessages({ ...errorMessages, file: '' });
        const file = event.target.files[0];
        setSelectedFile(file);
        readFileContent(file);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            const droppedFile = files[0];
            setSelectedFile(droppedFile);
            setErrorMessage("");
            readFileContent(droppedFile);
        }
        e.currentTarget.classList.remove('highlight');
    };

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const isValidUpload = () => {
        const errors = {};
        if (!formData.certificate_template_id) {
            errors.certificate_template_id = "Template is required.";
        }
        if (!selectedFile) {
            errors.file = "File is required.";
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    const handleFileUpload = async () => {
        if (isValidUpload()) {
            const headers = fileContent[0];
            const rows = fileContent.slice(1);

            const headerMapping = {};
            headers.forEach((header, index) => {
                headerMapping[header] = index;
            });

            const formattedRows = rows.map((row) => {
                return row;
            });

            const newSheetData = [headers, ...formattedRows];
            const newWorksheet = XLSX.utils.aoa_to_sheet(newSheetData);  // Convert array to worksheet
            const newWorkbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, "Sheet1");  // Append the new sheet to the workbook

            const workbookBinary = XLSX.write(newWorkbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([workbookBinary], { type: "application/octet-stream" });

            const bulkFormData = new FormData();
            bulkFormData.append('file', blob);
            bulkFormData.append('certificate_template_id', formData.certificate_template_id)
            try {
                const response = await dispatch(addNewBulk(bulkFormData)).unwrap();
                showToast('success', response.message);
                setBtnDisable(false);
                setSelectedFile(null);
                setFileContent(null);
                setSelectedType({
                    id: '',
                    name: ''
                });
                if (typeDropdownRef.current) {
                    typeDropdownRef.current.clearSelection();
                }
                setSelectedTemplate({
                    id: '',
                    name: ''
                });
                if (templateDropdownRef.current) {
                    templateDropdownRef.current.clearSelection();
                }

            } catch (error) {
                showToast('error', error.message);
                setSelectedFile(null);
                setFileContent(null);
            }
        }
    };

   const downloadSample = () => {
        let headers = [];

        if (selectedType.name === "OFFICIAL") {
            headers = OFFICIAL_HEADERS;
        } else if (selectedType.name === "OTHER") {
            headers = OTHER_HEADERS;
        } else {
            return;
        }

        const worksheet = XLSX.utils.aoa_to_sheet([headers]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

        const fileName =
            selectedType.name === "OFFICIAL"
                ? "Official_Sample.xlsx"
                : "Other_Sample.xlsx";

        XLSX.writeFile(workbook, fileName);
    };

     const currentHeaders =
        selectedType.name === "OFFICIAL"
            ? OFFICIAL_HEADERS
            : selectedType.name === "OTHER"
            ? OTHER_HEADERS
            : [];

    return (
        <div className={`card-section`}>
            <div className={`main-card`}>
                <h1 className={`form-title`}>Add New Bulk
                </h1>
                <div className={styles.formContainer}>
                    <form
                        className={styles.coordinatorForm}
                        noValidate
                    >
                        <div className={`form-input-row`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='lottery-brand' className={`form-label`}>
                                        Certificate Type<span className={`required-star`}>*</span>
                                    </label>
                                    <Dropdown
                                        ref={typeDropdownRef}
                                        options={certificateTypes}
                                        placeholder='Select a Type'
                                        onSelect={handleType}
                                        value={selectedType.name}
                                    />
                                    {errorMessages.type && (
                                        <p className={`text-danger`}>
                                            {errorMessages.type}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='lottery-brand' className={`form-label`}>
                                        Certificate Template<span className={`required-star`}>*{templateLoadng && <ClipLoader size={15} />}</span>
                                    </label>
                                    <Dropdown
                                        ref={templateDropdownRef}
                                        options={certificateTemplates}
                                        placeholder='Select a Template'
                                        onSelect={handleTemplate}
                                        value={selectedTemplate.name}
                                    />
                                    {errorMessages.certificate_template_id && (
                                        <p className={`text-danger`}>
                                            {errorMessages.certificate_template_id}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        File<span className={`required-star`}>*</span>
                                    </label>
                                    <div
                                        onDrop={handleDrop}
                                        onDragOver={(event) => event.preventDefault()}
                                        onClick={handleClick}
                                        className={`drop-input`}
                                    >
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            accept=".xlsx, .xls"
                                            onChange={handleFileChange}
                                            style={{ display: "none" }}
                                        />
                                        <p>Drag & Drop a file here or click to select</p>
                                    </div>
                                    {errorMessages.file && (
                                        <p className={`text-danger`}>{errorMessages.file}</p>
                                    )}
                                    {isErrorMessage && <p className={`text-danger`}>{isErrorMessage}</p>}
                                </div>
                            </div>
                        </div>
                        <div className={`table-container`}>
                            {fileContent && (
                            <div className={styles.tableContainer}>
                                <table className={styles.table}>
                                    <thead>
                                        <tr>
                                            {currentHeaders.map((header, i) => (
                                                <th key={i}>{header}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fileContent.slice(1, 6).map((row, i) => (
                                            <tr key={i}>
                                                {currentHeaders.map((header, j) => {
                                                    const index =
                                                        fileContent[0]?.indexOf(header);
                                                    return (
                                                        <td key={j}>
                                                            {index !== -1
                                                                ? row[index] || "-"
                                                                : "-"}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        </div>
                        <button
                            className={`btn-primary`}
                            type='button'
                            disabled={disabledBtn}
                            onClick={handleFileUpload}
                        >
                            {isBulkCreating ? <BeatLoader color='#ffffff' /> : `Create`}
                        </button>
                      {selectedType.id && (
                            <button
                                type="button"
                                className={`btn-primary ${styles.downloadBtn}`}
                                onClick={downloadSample}
                            >
                                Download Sample <FontAwesomeIcon icon={faDownload} />
                            </button>
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default BulkUpload;